// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"009e5486","32":"0b0cdafe","35":"8bcabb09","91":"ccb5400c","176":"d042c205","313":"85df7cf9","518":"1a805e40","606":"bfd4465a","611":"c5812b21","850":"eb0ea955"}[chunkId] + ".chunk.js";
};